import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { Feature } from '@/types/features';

export const GET_FEATURES_QUERY_KEY = 'get-features';

export const useGetFeaturesQuery = () => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_FEATURES_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      return getFeatures(token ?? '');
    },
    retry: false, // Don't retry on 404/403 errors
  });
};

const getFeatures = async (token: string): Promise<Feature[]> => {
  const url = `${import.meta.env.VITE_API_URL}/features`;
  const response = (await sendJSONRequest({ url, method: METHOD.GET, token })) as { data: Feature[] };
  return response.data;
};
